<!--
  隐私条款
-->
<template>
  <div>
    <iframe ref="barparent" :src="url" frameborder="0" width="100%" style="height:100vh"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: ``,
    }
  },
  mounted() {
    this.url=	window.open(`/campaign/statc/privacyPolicy.html`)
  },
  methods() {

  },
}
</script>

<style lang="less" scoped>

</style>
